/**
 * Encodes a filename for use in HTTP Content-Disposition headers.
 * Handles non-ASCII characters (e.g., Chinese, accented characters) that would
 * otherwise cause "String contains non ISO-8859-1 code point" errors.
 *
 * Uses RFC 5987 encoding (filename*=UTF-8'') which is widely supported.
 * Falls back to ASCII-only filename for maximum compatibility.
 */
export function encodeFilenameForHeader(filename: string): string {
  if (!filename) return '';

  const hasNonAscii = /[^\x00-\x7F]/.test(filename);

  if (!hasNonAscii) {
    return `attachment; filename="${filename}"`;
  }

  const asciiFilename = filename.replace(/[^\x00-\x7F]/g, '_');
  const encodedFilename = encodeURIComponent(filename).replace(/'/g, '%27');

  return `attachment; filename="${asciiFilename}"; filename*=UTF-8''${encodedFilename}`;
}
